import { Box } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import { PortesAnimal } from "core/features/animal/animal.data";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

export interface SelectPorteAnimalProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}

function SelectPorteAnimal({
  value,
  onChange,
  isInvalid,
  errorMessage,
  ...rest
}: SelectPorteAnimalProps) {
  const [search, setSearch] = useState<string | undefined>();

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      placeholder="Selecione o porte"
      style={{ width: "100%", flexGrow: 1, flex: 1 }}
      value={value || undefined}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={PortesAnimal}
      notFoundContent={<Box>Nenhum porte encontrada</Box>}
    />
  );
}

export default SelectPorteAnimal;
